import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import { useMoreVideos } from "@hooks/userMoreVideos";
import Card from "@particles/card/Card";
import MoreVideosCard from "@routes/Videos/VideosPage/components/MoreVideoCard";

type MoreVideosProps = {
  /** This is the classname of the component. */
  className?: string;
  /** This is the list of videos to be displayed. */
  videos: ComponentProps<typeof Card>[];
};

/** This is the component for displaying the more videos. */
const MoreVideos = ({
  className,
  videos,
}: MoreVideosProps): React.ReactElement => {
  const { moreVideos, ref } = useMoreVideos(videos);

  return (
    <div data-testid="more-videos-component" className={className}>
      <BlockTitle text="MORE VIDEOS" rootClassName="mb-3" />

      <div className="mb-8 grid gap-6 lg:grid-cols-2">
        {moreVideos.map((video, index) => {
          return <MoreVideosCard key={video.id} video={video} index={index} />;
        })}
      </div>

      <div ref={ref} />
    </div>
  );
};

export default MoreVideos;
